import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { ResolutionOutcomeEntity } from '../../Risks/models/Risk';

const actionConfig = { resourcePath: '/risks/resolution-outcomes' };

export const riskResolutionOutcomesActions = createRestActions<ResolutionOutcomeEntity>(actionConfig);

export const RiskResolutionOutcomesStore = createRestStore<ResolutionOutcomeEntity>({
  name: 'risk-resolution-outcomes-store',
  actions: riskResolutionOutcomesActions,
  actionConfig,
  containerDisplayName: 'risk-resolution-outcomes-container',
  onInitAction: null,
});

export const useRiskResolutionOutcomesData = createDataHook(RiskResolutionOutcomesStore);
export const useRiskResolutionOutcomesIsLoading = createLoadingHook(RiskResolutionOutcomesStore);
export const useRiskResolutionOutcomesActions = createActionsHook(RiskResolutionOutcomesStore);
export const didRiskResolutionOutcomesMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
